window.addEventListener('DOMContentLoaded', () => {
	const main = document.querySelector('#main');
	const nav = document.querySelector('#navbar-desktop');
	if (!main || main.children.length === 0 || !nav) return;
	const firstChild = main.children[0];
	if (
		firstChild.classList.contains('wp-block-cover') ||
		document.querySelector('header.tuote-header')
	) {
		nav.classList.add('has-body-hero');
		document.body.classList.add('has-body-hero');
	}
});

// Implements a spacer for the navigation to prevent content jump when nav is sticky
window.addEventListener('DOMContentLoaded', () => {
	const nav = document.querySelector('#navbar-desktop');
	if (!nav) return;

	// Avoid adding multiple spacers
	if (
		nav.previousElementSibling &&
		nav.previousElementSibling.classList.contains('nav-spacer')
	) {
		return;
	}

	const spacer = document.createElement('div');
	spacer.className = 'nav-spacer';
	spacer.style.height = nav.offsetHeight + 'px';
	spacer.style.width = '100%';

	nav.parentNode.insertBefore(spacer, nav);

	// Update spacer height on resize in case nav height changes
	function updateNavSpacer() {
		spacer.style.height = nav.offsetHeight + 'px';
	}
	window.addEventListener('resize', updateNavSpacer);
	setInterval(updateNavSpacer, 1000);
});
